import { render } from "./appFooter.vue?vue&type=template&id=1be99dd8"
const script = {}

import exportComponent from "D:\\gitrepos\\QNBPayHelp\\apidocs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__